import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashboardLayout from "./components/DashboardLayout";
import HeaderOnlyLayout from "./components/HeaderOnlyLayout";
import Login from "./pages/Login";
import PatientStart from "./pages/PatientStart";
import PreInterview from "./pages/PreInterview";
import AiInterview from "./pages/AiInterview";
import Thanks from "./pages/Thanks";
import PatientRegistration from "./pages/PatientRegistration";
import ManualInput from "./pages/ManualInput";
import Upload from "./pages/Upload";
import Summary from "./pages/Summary";
import PatientSelection from "./pages/PatientSelection";
import ApSelection from "./pages/ApSelection";
import BasicInfo from "./pages/BasicInfo";
import ConsultationRecords from "./pages/ConsultationRecords";
import Consultation from "./pages/Consultation";
import AiInterviewScores from "./pages/AiInterviewScores";
import AiInterviewQuestions from "./pages/AiInterviewQuestions";
import TestResults from "./pages/TestResults";

// ← 追加
import PrivateRoute from "./auth/PrivateRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ログイン */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />

        {/* ヘッダー有・サイドバー無しの共通レイアウト */}
        <Route
          element={
            <PrivateRoute>
              <HeaderOnlyLayout />
            </PrivateRoute>
          }
        >
          {/* 患者系 */}
          <Route path="/patient-start" element={<PatientStart />} />
          <Route path="/pre-interview" element={<PreInterview />} />
          <Route path="/ai-interview" element={<AiInterview />} />

          {/* 新規患者登録 */}
          <Route path="/patient-registration" element={<PatientRegistration />} />
          <Route path="/patient-registration/manual" element={<ManualInput />} />
          <Route path="/patient-registration/upload" element={<Upload />} />

          <Route path="/patient-selection" element={<PatientSelection />} />
          <Route path="/ap-selection" element={<ApSelection />} />
          <Route path="/thanks" element={<Thanks />} />
        </Route>

        {/* ダッシュボード配下 */}
        <Route
          element={
            <PrivateRoute requirePatient>
              <DashboardLayout />
            </PrivateRoute>
          }
        >
          <Route path="/summary" element={<Summary />} />
          <Route path="/basic-info" element={<BasicInfo />} />
          <Route path="/consultation-records" element={<ConsultationRecords />} />
          <Route path="/consultation" element={<Consultation />} />
          <Route path="/ai-interview-scores" element={<AiInterviewScores />} />
          <Route path="/ai-interview-questions" element={<AiInterviewQuestions />} />
          <Route path="/test-results" element={<TestResults />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
